import React from "react";
import { Link } from "react-router-dom";
import { CircleHelp, Mail, ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";

import "./PlatformFooter.css";
import footerLogo from "../../assets/footer_logo.png";

/**
 * A restrained, application-style footer for the LEG-UP platform.
 *
 * Uses the existing `common.footer` translation keys:
 * - copyright
 * - eu
 * - contact
 * - faq
 * - quickLinks (falls back to "Support links")
 *
 * If your router uses different paths, update /contact and /faq below.
 */
export default function PlatformFooter() {
  const { t } = useTranslation("common");

  return (
    <footer className="platform-footer">
      <div className="platform-footer__inner">
        <div className="platform-footer__top">
          <div className="platform-footer__brand">
            <img
              src={footerLogo}
              alt="LEG-UP"
              className="platform-footer__brand-logo"
            />
          </div>

          <nav
            className="platform-footer__links"
            aria-label={t("footer.quickLinks", "Support links")}
          >
            <Link to="/contact" className="platform-footer__link">
              <Mail size={17} strokeWidth={1.8} aria-hidden="true" />
              <span>{t("footer.contact", "Contact")}</span>
              <ArrowUpRight
                className="platform-footer__link-arrow"
                size={15}
                strokeWidth={1.8}
                aria-hidden="true"
              />
            </Link>

            {/* <Link to="/faq" className="platform-footer__link">
              <CircleHelp size={17} strokeWidth={1.8} aria-hidden="true" />
              <span>{t("footer.faq", "FAQ")}</span>
              <ArrowUpRight
                className="platform-footer__link-arrow"
                size={15}
                strokeWidth={1.8}
                aria-hidden="true"
              />
            </Link> */}
          </nav>
        </div>

        <div className="platform-footer__bottom">
          <p className="platform-footer__copyright">{t("footer.copyright")}</p>
          <p className="platform-footer__eu">{t("footer.eu")}</p>
        </div>
      </div>
    </footer>
  );
}
